import React from 'react';

import { capitalize } from 'lodash';

/**
 * Return referer in full text
 * @param {Object} props {referer}
 * @returns {JSX.Element} Referer
 * @constructor
 */
const Referer = props => {
  const referers = {
    capifrance: 'Capifrance',
    capifrance_jeuconcours2022: 'Capifrance',
    optimhome: 'OptimHome',
    refleximmo: 'Refleximmo',
    inconnu: 'Inconnu',
    leboncoin: 'Le bon coin',
    seloger: 'Se Loger',
    logicimmo: 'Logic-immo',
    avendrealouer: 'A vendre à louer',
    paruvendu: 'ParuVendu',
    explorimmo: 'Explorimmo',
    luxresidence: 'Lux résidence',
    domimmo: 'Domimmo',
    topannonce: 'Tom annonce',
    annoncesjaunes: 'Annonces jaunes',
    lesclesdumidi: 'Les clés du midi',
    repimmo: 'Repimmo',
    tac: 'Tac',
    drimki: 'Drimki',
    capital: 'Capital',
    lavieimmo: 'La vie immo',
    immodanger: 'Immodanger',
    trouver_logement_neuf: 'Trouve logement neuf',
    visite_online_network: 'Visite online network',
    ouestfranceimmo: 'Ouest france immo',
    dili: 'Dili',
    meilleurtaux: 'Meilleur taux',
    visite_online: 'Visite Online',
    mandatoptimust: 'Mandat Optimust',
    empruntis: 'Empruntis',
    empruntisagence: 'Empruntis Agence',
    immopret: 'Immoprêt',
    acecredit: 'ACE Credit Courtier',
    express: 'Express',
    leparisien: 'Le parisien',
    magnolia: 'Magnolia',
    lcf: 'Lcf',
    drimki_mobile: 'Drimki mobile',
    reassurez_moi: 'Réassurez moi',
    toutsurmesfinances: 'Tout sur mes finances',
    boursier: 'Boursier',
    mysweetimmo: 'My Sweet Immo',
    independancefinanciere: 'Indépendance Financière',
    drimki_capifrance: 'Capifrance',
    drimki_optimhome: 'OptimHome',
    malin: 'Emprunter Malin',
    hosman: 'Hosman',
    chasseur_immo: 'Chasseur Immobilier',
    lcf_siege: 'Lcf',
    magnolia_siege: 'Magnolia',
    ace_siege: 'Ace',
    immopret_siege: 'Immoprêt',
    empruntis_agence_siege: 'Empruntis',
    empruntis_siege: 'Empruntis',
    cherchemonnid: 'Cherche mon nid',
    tvb: 'Toutvabiens',
    tvb_rdv: 'Toutvabiens (rdv)',
  };

  const referer = partner => {
    const referer = partner.toString().toLowerCase();
    if (referers[referer]) {
      return referers[referer];
    }

    return capitalize(partner);
  };

  return <span>{referer(props.referer)}</span>;
};

export default Referer;
